import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './KYCPending.css';

function KYCPending() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reviewNotes, setReviewNotes] = useState('');
  const [selectedApp, setSelectedApp] = useState(null);

  useEffect(() => {
    fetchPendingApplications();
  }, []);

  const fetchPendingApplications = async () => {
    try {
      const response = await axios.get('https://trcsite.net/api/admin/kyc/pending');
      setApplications(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching KYC applications:', error);
      alert('Failed to fetch KYC applications');
      setLoading(false);
    }
  };

  const reviewApplication = async (applicationId, status) => {
    if (status === 'rejected' && !reviewNotes.trim()) {
      alert('Please provide review notes for rejection');
      return;
    }

    try {
      await axios.post(`https://trcsite.net/api/admin/kyc/${applicationId}/review`, {
        status,
        review_notes: reviewNotes
      });
      
      setReviewNotes('');
      setSelectedApp(null);
      fetchPendingApplications();
      alert(`KYC application ${status} successfully!`);
    } catch (error) {
      console.error('Error reviewing KYC application:', error);
      alert('Failed to review KYC application');
    }
  };

  // Function to handle image preview
  const ImagePreview = ({ src, alt, type }) => (
    <div style={{ marginBottom: '10px' }}>
      <strong style={{ color: '#b0b8c4', display: 'block', marginBottom: '5px' }}>{type}:</strong>
      {src ? (
        <div>
          <img 
            src={src} 
            alt={alt}
            style={{
              maxWidth: '100%',
              maxHeight: '300px',
              border: '1px solid #344258',
              borderRadius: '4px',
              marginBottom: '5px'
            }}
          />
          <br />
          <a 
            href={src} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              color: '#2962ff',
              textDecoration: 'none',
              fontSize: '14px'
            }}
          >
            🔍 Open in new tab
          </a>
        </div>
      ) : (
        <div style={{ color: '#ff6b6b', fontStyle: 'italic' }}>
          No {type.toLowerCase()} uploaded
        </div>
      )}
    </div>
  );

  if (loading) {
    return <div className="loading">Loading KYC applications...</div>;
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>KYC Verification Queue</h1>
        <p>Review and approve user identity verifications</p>
        <div style={{ 
          backgroundColor: '#2a3b52', 
          padding: '10px', 
          borderRadius: '4px',
          marginBottom: '20px'
        }}>
          <strong>Pending Applications: {applications.length}</strong>
        </div>
      </div>

      <div className="chart-section">
        {applications.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#b0b8c4', padding: '40px' }}>
            No pending KYC applications.
          </div>
        ) : (
          applications.map((application) => (
            <div key={application.id} style={{
              backgroundColor: '#2a3b52',
              border: '1px solid #344258',
              borderRadius: '8px',
              padding: '20px',
              marginBottom: '20px'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                <div>
                  <h3 style={{ color: '#ffffff', marginBottom: '5px' }}>
                    {application.user_name}
                  </h3>
                  <p style={{ color: '#b0b8c4', margin: 0 }}>{application.email}</p>
                  <p style={{ color: '#b0b8c4', margin: '5px 0', fontSize: '14px' }}>
                    Joined: {new Date(application.user_joined).toLocaleDateString()}
                  </p>
                  <p style={{ color: '#b0b8c4', margin: '5px 0', fontSize: '14px' }}>
                    Document: {application.document_type.toUpperCase()} - {application.document_number}
                  </p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ 
                    padding: '4px 8px', 
                    backgroundColor: 'rgba(255, 167, 38, 0.2)',
                    color: '#ffa726',
                    borderRadius: '4px',
                    fontSize: '12px',
                    display: 'inline-block'
                  }}>
                    PENDING REVIEW
                  </div>
                  <p style={{ color: '#b0b8c4', margin: '5px 0', fontSize: '12px' }}>
                    Submitted: {new Date(application.submitted_at).toLocaleString()}
                  </p>
                </div>
              </div>

              {/* Image Previews */}
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: '1fr 1fr', 
                gap: '20px',
                marginBottom: '20px'
              }}>
                <div>
                  <ImagePreview 
                    src={application.document_front_url} 
                    alt="Document Front" 
                    type="Document Front"
                  />
                </div>
                <div>
                  <ImagePreview 
                    src={application.document_back_url} 
                    alt="Document Back" 
                    type="Document Back"
                  />
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <ImagePreview 
                    src={application.selfie_url} 
                    alt="Selfie with Document" 
                    type="Selfie with Document"
                  />
                </div>
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ color: '#b0b8c4', display: 'block', marginBottom: '5px' }}>
                  Review Notes:
                </label>
                <textarea
                  value={selectedApp === application.id ? reviewNotes : ''}
                  onChange={(e) => {
                    setReviewNotes(e.target.value);
                    setSelectedApp(application.id);
                  }}
                  placeholder="Enter review notes (required for rejection)"
                  style={{
                    width: '100%',
                    minHeight: '80px',
                    backgroundColor: '#1e2a3a',
                    border: '1px solid #344258',
                    borderRadius: '4px',
                    color: '#ffffff',
                    padding: '10px',
                    resize: 'vertical'
                  }}
                />
              </div>

              <div style={{ display: 'flex', gap: '10px' }}>
                <button
                  onClick={() => reviewApplication(application.id, 'approved')}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#00c853',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    flex: 1
                  }}
                >
                  Approve
                </button>
                <button
                  onClick={() => {
                    if (!reviewNotes.trim() && selectedApp === application.id) {
                      alert('Please provide review notes for rejection');
                      return;
                    }
                    reviewApplication(application.id, 'rejected');
                  }}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#ff1744',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    flex: 1
                  }}
                >
                  Reject
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default KYCPending;